module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUFJREFUSEu1lc9LwzAUx99rql3HbqNN6Q/wsLP/gD8QhP27XjwJggzFU+8ePFTaukXx3M6aRSIIQ1zTpF2ubd+n7/O+SRD2vHDP9cEI4HlHASI/Ho/JIsuyuu0ntQFBMPM4ry6EsOzJhFwNCkiSJKzrzQkicsTmnjH2plLcuQNZvKrgHACQkM9bxtg7AIhBANtaHGdzU5blh6rw73NlByZatuGtAFMtnQB9tCgBMucAzZlOWnbN5F9Fvp/MhYDYtq3H5fLlqUtatABRFE3Xa2uOuPkixL1brZ5lJI3WziFTSn0hDk6FEGQ0sh7yPH81IbSlCCmlHueHl1KR68LCBKLcB311KQFSSx9dnQDy/DHV1RXwM18TXVqAv7ocB6+LoqgGvXCkrjAMp5zjLI6DNE3TZmiA1nbQVqRVXbar+4Hu+99foqwZ+9uUrwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_left.png
// module id = akaD
// module chunks = 1